
import { mapGetters } from 'vuex'

import NewBattery from '../NewBattery'
import { ARROW_POSITIONS } from '../NewBattery/components/Arrow/Arrow.constants'
import PickerColor from '../PickerColor'
import PickerGrade from '../PickerGrade'
import PickerStorage from '../PickerStorage'

export default {
  components: {
    PickerColor,
    PickerGrade,
    PickerStorage,
    NewBattery,
  },

  props: {
    activeBackboxGrade: {
      type: Number,
      default: 0,
    },
    isAccessory: {
      type: Boolean,
      default: false,
    },
    deviceName: {
      type: String,
      required: true,
    },
    displayVariant: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: Array,
      default: () => [],
    },
    grades: {
      type: Array,
      default: () => [],
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
    storages: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      loadingId: null,
    }
  },

  computed: {
    ...mapGetters({
      experiments: 'flags/getExperiments',
    }),

    activeGradeIndex() {
      return this.grades.findIndex(
        ({ backboxGrade }) => backboxGrade.value === this.activeBackboxGrade,
      )
    },

    shouldDisplayNewBattery() {
      return (
        this.experiments.ppNewBattery === 'withBattery' &&
        this.newBatteryStatus !== 'not-available'
      )
    },

    newBatteryArrowPosition() {
      return ARROW_POSITIONS[this.activeGradeIndex]
    },

    newBatteryStatus() {
      const activeGrade = this.grades[this.activeGradeIndex]

      return activeGrade?.newBattery?.status ?? 'not-available'
    },

    newBatteryProps() {
      return {
        deviceName: this.deviceName,
        disabled: this.newBatteryStatus === 'disabled',
        arrowPosition: this.newBatteryArrowPosition,
        offerType: this.grades[this.activeGradeIndex].newBattery?.offerType,
      }
    },

    pickerGradesClassNames() {
      return [
        {
          'mb-7': !this.shouldDisplayNewBattery,
          'mb-3': this.shouldDisplayNewBattery,
        },
      ]
    },
  },

  watch: {
    $route({ params: newParams } = {}, { params: oldParams } = {}) {
      if (newParams?.uuid !== oldParams?.uuid) {
        this.loadingId = null
      }
    },
  },

  methods: {
    clickOnLinkPicker(itemId) {
      if (this.$route.params.uuid !== itemId.toString()) {
        this.loadingId = itemId
      }
    },
  },
}
